import { useCallback } from 'react';
import { usePermission } from '../../hooks/use-permission';

const boundaryLayers = [
  {
    id: 'boundary-uncertified',
    name: 'Uncertified Fields',
    minZoom: 4,
    visible: true,
  },
  {
    id: 'boundary',
    name: 'Certified Fields',
    minZoom: 4,
    visible: true,
  },
];

const irrigationLayers = [
  {
    id: 'irrigation-boundary',
    name: 'Irrigation Boundaries',
    minZoom: 4,
    visible: true,
  },
];

export function useLayers() {
  const canManageIrrigation = usePermission('MANAGE_IRRIGATION');

  return useCallback(
    (supportingLayers) => [
      ...supportingLayers
        .filter((layer) => layer.id !== 'boundary')
        .concat(canManageIrrigation ? irrigationLayers : [])
        .concat(boundaryLayers),
    ],
    [canManageIrrigation],
  );
}
